import * as React from 'react';

import { GalleryPlaceholderData, PropertyListingContext, SummaryPlaceholderData } from './property-listing-context';
import { PropertyFields } from '__generated__/api';

export interface PropertyListingProviderProps {
  propertyListing: PropertyFields.Fragment;
}

export function createGalleryPlaceholderDataHelper(property: PropertyFields.Fragment): () => GalleryPlaceholderData {
  return () => {
    if (property?.propertyGallery) {
      return {
        propertyGallery: { images: property.propertyGallery },
      };
    }
  };
}

export function createSummaryPlaceholderDataHelper(property: PropertyFields.Fragment): () => SummaryPlaceholderData {
  return () => {
    if (property) {
      const { name, star, starRatingIcon, vipMessaging } = property;

      return {
        summary: {
          name,
          overview: {
            vipMessaging,
            starRating: star,
          },
          starRatingIcon: {
            id: starRatingIcon,
          },
        },
      };
    }
  };
}

export const PropertyListingProvider: React.FC<PropertyListingProviderProps> = ({ children, propertyListing }) => {
  const props = {
    ...propertyListing,
    getGalleryPlaceholderData: createGalleryPlaceholderDataHelper(propertyListing),
    getSummaryPlaceholderData: createSummaryPlaceholderDataHelper(propertyListing),
  };

  return <PropertyListingContext.Provider value={props}>{children}</PropertyListingContext.Provider>;
};
